import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  scheduleFrequency:[],
  formats:[],
  reportNames:[],
  emailDetails:[],
  daysOfWeek:[],
  daysOfMonth:[],
  isLoading:false,
  mailScheduleDetails:{
    head:[ { label: "Schedule Name", align: "left", },
    { label: "Frequency", align: "left" },
    { label: "Report Name", align: "left" },
    { label: "Format", align: "left" },
    { label: "Email Detail", align: "left" },
    { label: "Enabled", align: "left" },
    { label: "Action", align: "right" },
   ],
    body:[]
  },
  fullData:[],
  isTableLoading:false
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_MAILSCHEDULE:
      return{
        ...state,
        scheduleFrequency:action.data.scheduleFrequency,
        formats:action.data.format,
        reportNames:action.data.reports,
        daysOfWeek:action.data.dayOfWeek,
        daysOfMonth:action.data.dayofmonth,
        emailDetails:action.data.emailDetails
      }
    case types.FAILED_MAILSCHEDULE:
      return{
        ...state,
        isLoading:action.data
      }
    case types.LOADING_MAILSCHEDULE:
      return {
        ...state,
        isLoading: action.data,
      }
    case types.SUCCESS_MAILSCHEDULE_TABLE:
      var data=[]
      action.data.map(item=>{
        //console.log(item)
          data.push([item.scheduleName,item.scheduleFrequency,item.reportName,item.format,item.emailDetail,item.enabled==true?'Yes':'No',{id:item.id}])
      })
      return {
        ...state,
        mailScheduleDetails: {...state.mailScheduleDetails,body:data},
        fullData:action.data
      }

    case types.FAILED_MAILSCHEDULE_TABLE:
    return{
        ...state,
        mailScheduleDetails:{...state.mailScheduleDetails,body:[]}
      }
    case types.LOADING_MAILSCHEDULE_TABLE:
    return{
      ...state,
      isTableLoading:action.data
    }
    default:
      return state
  }
}
export default reducer
